/*  open /Applications/Google\ Chrome.app --args --user-data-dir="/var/tmp/Chrome dev session" --disable-web-security */

import axios from "axios";
import { setErrors, submitForm } from "@formkit/vue";

import { onBeforeMount, defineComponent, ref } from "vue";
interface FormData {
  [key: string]: string | undefined;
}

export default defineComponent({
  props: {
    apiUrl: { type: String, required: true },
    schema: { type: Array, required: true },
    contactform: { type: String, required: true },
  },
  setup(props) {
    const formdata = ref<FormData>({});
    const submitted = ref(false);
    const notification = ref("");

    onBeforeMount(() => {
      formdata.value = { submitForm: "1", contactform: props.contactform };
    });

    const submitFromExternalButton = (): void => {
      submitForm(props.contactform);
    };
    const sendToApi = async (): Promise<void> => {
      try {
        const params = new URLSearchParams();

        Object.keys(formdata.value).forEach((key) => {
          params.append(key, formdata.value[key] as string);
        });

        const response = await axios.post(props.apiUrl, params);

        submitted.value = true;
        notification.value = response.data;
      } catch (error) {
        setErrors(
          props.contactform,
          ["Er is iets mis gegaan!"] // (optional) An array of form level errors
        );
      }
    };

    return {
      formdata,
      submitted,
      notification,
      sendToApi,
      submitFromExternalButton,
    };
  },
});
